import { ChartOptions } from "chart.js"

export const fixedOptions: ChartOptions<"line"> = {
  responsive: true,
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        autoSkip: true,
        includeBounds: true,
        maxRotation: 180,
        minRotation: 0,
        font: {
          size: 12,
        },
      },
    },
    y: {
      min: 0,
      grace: `20%`,
      grid: {
        display: false,
      },
      beginAtZero: true,
      ticks: {
        font: {
          size: 12,
        },
      },
    },
  },
  plugins: {
    datalabels: {
      display: false,
    },
    tooltip: {
      padding: {
        top: 8,
        right: 10,
        bottom: 8,
        left: 10,
      },
      titleFont: { weight: `bold`, size: 12, family: `'MessinaSansCondensed', sans-serif` },
      titleMarginBottom: 2,
      bodyFont: { weight: `bold`, size: 16, family: `'MessinaSansCondensed', sans-serif` },
    },
  },
}
